import { selectPavilionersInitWaitingMessage, selectPavilionersInStore, selectPavilionersPageLoading, selectPavilionsInitWaitingMessage } from './../_selectors/pavilion.selectors';
// RxJS
import { delay, distinctUntilChanged } from 'rxjs/operators';
// CRUD
import { QueryResultsModel, BaseDataSource } from '../../_base/crud';
// State
import { Store, select } from '@ngrx/store';
import { AppState } from '../../reducers';
// Selectors
import { selectPavilionsInStore, selectPavilionsPageLoading } from '../_selectors/pavilion.selectors';

export class PavilionsDataSource extends BaseDataSource {
	constructor(private store: Store<AppState>) {
		super();
		this.loading$ = this.store.pipe(
			select(selectPavilionsPageLoading)
		);

		this.isPreloadTextViewed$ = this.store.pipe(
			select(selectPavilionsInitWaitingMessage)
		);

		this.store.pipe(
			select(selectPavilionsInStore)
		).subscribe((response: QueryResultsModel) => {
			this.paginatorTotalSubject.next(response.totalCount);
			this.entitySubject.next(response.items);
		});
	}
}

export class PavilionersDataSource extends BaseDataSource {
	constructor(private store: Store<AppState>) {
		super();
		this.loading$ = this.store.pipe(
			select(selectPavilionersPageLoading)
		);

		this.isPreloadTextViewed$ = this.store.pipe(
			select(selectPavilionersInitWaitingMessage)
		);

		this.store.pipe(
			select(selectPavilionersInStore)
		).subscribe((response: QueryResultsModel) => {
			this.paginatorTotalSubject.next(response.totalCount);
			this.entitySubject.next(response.items);
		});
	}
}
